import httpClient from "@/apis/base/axios-httpclient";
import BaseAPI from "@/apis/base/base-api";

class CollectionPeriodAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "PaymentRequest";
  controllerName = "receivableperiods";
  /**
   * @override: Lấy dữ liệu danh sách
   * Created by: TMQUY 28/08/2021
   */
  getList(payload) {
    // URL mặc định
    let param = {
      maxResultCount: payload.take || 20,
      filter: payload.filter || null,
      skipCount: payload.skip || 0,
      sorting: payload.Sort || null,
    };
    let url = this.getAPIUrl() + "/list";
    // Build tham số
    let request = {
      url: url,
      data: param,
    };
    // Call api
    return httpClient.postAsync(request);
  }

  /**
   * Tạo mới kỳ thanh toán
   * CreatedBy: tmquy (28/06/2022)
   */
  createAsync(payload) {
    let url = this.getAPIUrl();
    // Build tham số
    let request = {
      url: url,
      data: payload,
    };
    // Call api
    return httpClient.postAsync(request);
  }

  /**
   * Tạo mới kỳ thanh toán
   * CreatedBy: pvtruong (13/07/2022)
   */
  duplicateAsync(payload) {
    let url = this.getAPIUrl() + "/duplicate";
    // Build tham số
    let request = {
      url: url,
      data: payload,
    };
    // Call api
    return httpClient.postAsync(request);
  }

  /**
   * Lấy period bằng id
   * CreatedBy: tmquy (29/06/2022)
   */
  getById(id) {
    let url = this.getAPIUrl() + `/${id}`;
    // Build tham số
    let request = {
      url: url,
    };
    // Call api
    return httpClient.getAsync(request);
  }

  /**
   * Gửi cho toàn bộ yctt chưa dược thông báo trong kỳ thu
   * CreatedBy: pvtruong (13/07/2022)
   */
  sendPaymentPeriod(id) {
    var idPeriod = id ? id : null;
    let url = this.getAPIUrl() + "/send/" + idPeriod;
    let request = {
      url: url,
    };
    // Call api
    return httpClient.postAsync(request);
  }

  /**
   * Lấy số liệu thống kê
   * CreatedBy: tmquy (27/06/2022)
   */
  getStatistical(periodId) {
    let url = this.getAPIUrl() + `/statistical?id=${periodId}`;
    let request = {
      url: url,
    };
    return httpClient.getAsync(request);
  }
}
export default new CollectionPeriodAPI();
